<template>
  <div class="popupText">
    <div class="text">
      <div class="text_title"><span v-if="remind"><i class="el-icon-warning-outline"></i></span>{{ title }}</div>
      <div class="text_inner" v-html="text"></div>
      <div class="text_file">
        <slot></slot>
      </div>
    </div>
    <div class="btn">
      <button type="button" class="btn_primary" @click="checkBTN">確認</button>
    </div>
  </div>
</template>
<style lang="scss">
.popupText {
  font-size: 14px;
  letter-spacing: 2px;
  margin: 0 auto;
  text-align: left;
  width: fit-content;

  .text {
    margin: 20px 0 0 0;

    .text_title {
      font-size: 20px;
      font-weight: bold;
      color: var(--mainColor);
      margin: 5px 0 20px 0;
      text-align: center;

      span {
        margin: 0 5px;
        color: red;
        font-size: 25px;
      }
    }

    .text_file {
      margin: 20px 0 10px 0;
    }
  }

  .btn {
    margin: 20px 0 0 0;
  }

  .checkAnimate {
    animation: check 0.5s 0.1s backwards ease-in-out;
    // clip-path: inset(0 100% 0 0);
  }
}
</style>
<script>
export default {
  name: "popup_success",
  props: {
    title: String,
    text: String,
    remind: Boolean,
  },
  methods: {
    checkBTN() {
      this.$emit("check");
    }
  }
};
</script>